import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import axios from "axios";
import { Authorization } from "../../../Context/Authorization";
import Preloader from "../../../shared/PreLoaders";

import { Table, Modal, Button } from "react-bootstrap";

const VfcRevolvingFund = () => {
  const { vfcId } = useParams();
  const [vfc, setVfc] = useState(null);
  const [loading, setLoading] = useState(true);
  const [loanData, setLoanData] = useState({});
  const [selectedGender, setSelectedGender] = useState(null);
  const [modalData, setModalData] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const navigate = useNavigate();
  const Api = process.env.REACT_APP_API;
  const LOCAL_KEY = `vfcLoanSummaryData_${vfcId}`;

  const saveToLocalCache = (data) => {
    localStorage.setItem(
      LOCAL_KEY,
      JSON.stringify({ vfcData: data, timestamp: new Date().toISOString() })
    );
  };

  const loadFromLocalCache = () => {
    const cached = localStorage.getItem(LOCAL_KEY);
    return cached ? JSON.parse(cached) : null;
  };

  const fetchVFCDetails = async () => {
    try {
      const config = Authorization();
      const res = await axios.get(
        `${Api}/api/drill/loan/by-vfc/${vfcId}`,
        config
      );
      setVfc(res.data.data);
      saveToLocalCache(res.data.data);
    } catch (err) {
      console.error("Failed to fetch VFC data:", err);
    } finally {
      setLoading(false);
    }
  };
  // Load member loan data for modal
  const fetchLoanDetails = async () => {
    try {
      const config = Authorization();
      const res = await axios.get(
        `${Api}/api/drill/loan/by-member/${vfcId}`,
        config
      );
      setLoanData(res.data.data);
    } catch (err) {
      console.error("Failed to fetch VFC member loans:", err);
    }
  };
  useEffect(() => {
    setLoading(true);
    const cached = loadFromLocalCache();
    if (cached && cached.vfcData) {
      setVfc(cached.vfcData);
      setLoading(false);
    } else {
      fetchVFCDetails();
    }
    fetchLoanDetails(); // load members once
  }, [vfcId]);

  const formatDateTime = (ts) => {
    const date = new Date(ts);
    return date.toLocaleString("en-IN", { timeZone: "Asia/Kolkata" });
  };
  const handleGenderClick = (gender) => {
    if (!loanData || !loanData["Revolving Fund"]) return;
    const filtered = loanData["Revolving Fund"].filter(
      (m) => m.gender?.toLowerCase() === gender
    );
    setSelectedGender(gender);
    setModalData(filtered);
    setShowModal(true);
  };

  if (loading) return <Preloader loading={true} />;
  if (!vfc)
    return <p className="text-danger m-5">VFC not found or access denied.</p>;

  // Always using revolving fund data
  const totalMembers = vfc.totalMembers || {};
  const beneficiaries = vfc.revolvingFundLoanBeneficiaries;
  const notTaken = vfc.revolvingFundLoanNotTaken;
  const loanAmount = vfc.revolvingFundLoanAmount;

  return (
    <div>
      <div className="page-header">
        <h3 className="page-title">VFC - {vfc.vfcName}</h3>
        <nav aria-label="breadcrumb">
          <ol className="breadcrumb">
            <li
              className="breadcrumb-item"
              style={{
                color: "blue",
                textDecoration: "underline",
                cursor: "pointer",
              }}
              onClick={() => navigate(-1)}
            >
              ← Back
            </li>
            <li
              className="breadcrumb-item active"
              style={{ color: "red", cursor: "pointer" }}
              onClick={() => navigate("/dashboard")}
            >
              🏠 Home
            </li>
          </ol>
        </nav>
      </div>

      <div className="d-flex justify-content-between align-items-center mb-3 px-2">
        <button
          className="btn btn-sm btn-outline-secondary"
          onClick={() => {
            localStorage.removeItem(LOCAL_KEY);
            setLoading(true);
            fetchVFCDetails();
            fetchLoanDetails();
          }}
        >
          🔄 Refresh Now
        </button>

        <div className="text-muted small">
          Last Refreshed:{" "}
          {loadFromLocalCache()?.timestamp
            ? formatDateTime(loadFromLocalCache().timestamp)
            : "Not Available"}
        </div>
      </div>

      <div className="card bg-gradient-primary card-img-holder text-white mb-4">
        <div className="card-body">
          <img
            src={require("../../../../assets/images/dashboard/circle.png")}
            className="card-img-absolute"
            alt="circle"
            style={{ pointerEvents: "none" }}
          />
          <h4 className="font-weight-normal mb-3">
            VFC - {vfc.vfcName} (Revolving Fund Loan)
          </h4>
        </div>
      </div>

      <Table bordered className="text-center mt-4">
        <thead>
          <tr className="table-info">
            <th>VFC</th>
            <th>Range</th>
            <th>Division</th>
            <th>Circle</th>
            <th>Loan Amount</th>
            <th>Beneficiaries</th>
            <th>Not Availed</th>
            <th>Total Members</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>{vfc.vfcName}</td>
            <td>{vfc.rangeName}</td>
            <td>{vfc.divisionName}</td>
            <td>{vfc.circleName}</td>
            <td>₹{loanAmount.toLocaleString("en-IN")}</td>

            <td>
              <Table bordered size="sm" className="mb-0">
                <thead>
                  <tr>
                    <th
                      style={{ cursor: "pointer", color: "blue" }}
                      onClick={() => handleGenderClick("male")}
                    >
                      Male
                    </th>
                    <th
                      style={{ cursor: "pointer", color: "blue" }}
                      onClick={() => handleGenderClick("female")}
                    >
                      Female
                    </th>
                    <th
                      style={{ cursor: "pointer", color: "blue" }}
                      onClick={() => handleGenderClick("others")}
                    >
                      Third Gender
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>{beneficiaries?.male || 0}</td>
                    <td>{beneficiaries?.female || 0}</td>
                    <td>{beneficiaries?.others || 0}</td>
                  </tr>
                </tbody>
              </Table>
            </td>

            <td>
              <Table bordered size="sm" className="mb-0">
                <thead>
                  <tr>
                    <th>Male</th>
                    <th>Female</th>
                    <th>Third Gender</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>{notTaken?.male || 0}</td>
                    <td>{notTaken?.female || 0}</td>
                    <td>{notTaken?.others || 0}</td>
                  </tr>
                </tbody>
              </Table>
            </td>
            <td>
              <Table bordered size="sm" className="mb-0">
                <thead>
                  <tr>
                    <th>Male</th>
                    <th>Female</th>
                    <th>Others</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>{totalMembers.male || 0}</td>
                    <td>{totalMembers.female || 0}</td>
                    <td>{totalMembers.others || 0}</td>
                  </tr>
                </tbody>
              </Table>
            </td>
          </tr>
        </tbody>
      </Table>
      <Modal size="lg" show={showModal} onHide={() => setShowModal(false)}>
        <Modal.Header closeButton>
          <Modal.Title>
            {selectedGender?.toUpperCase()} Members - Loan Details
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Table bordered size="sm" className="text-center">
            <thead className="table-info">
              <tr>
                <th>Member Name</th>
                <th>Loan No</th>
                <th>Gender</th>
                <th>Disbursed</th>
                <th>Loan Date</th>
              </tr>
            </thead>
            <tbody>
              {modalData.length === 0 ? (
                <tr>
                  <td colSpan="5" className="text-danger">
                    No members found.
                  </td>
                </tr>
              ) : (
                modalData.map((member, i) =>
                  member.loans.map((loan, j) => (
                    <tr key={`${i}-${j}`}>
                      <td>{i + 1}</td>
                      <td>{member.memberName}</td>
                      <td>{loan.loanNo}</td>
                      <td>{member.gender}</td>
                      <td>
                        ₹{(loan.disbursedAmount || 0).toLocaleString("en-IN")}
                      </td>
                      <td>{loan.loanGivenDate}</td>
                    </tr>
                  ))
                )
              )}
            </tbody>
          </Table>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowModal(false)}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default VfcRevolvingFund;
